module.exports = __webpack_public_path__ + "static/media/Avatar1b.01a79651.png";